'use strict';

angular
  .module('openDataApp', [
    'ui.router',
    'ngResource',
    'ngCookies',
    'ngAnimate',
    'angularMoment',
    'ngTagsInput',
    'hljs'
  ])
  .config(['$stateProvider', '$urlRouterProvider', '$locationProvider',
    function ($stateProvider, $urlRouterProvider, $locationProvider) {

      var subdomain = window.location.host.replace('www.', '').split('.')[0],
          subdomainFolder = 'main';

      if (subdomain === 'openiban') {
        subdomainFolder = 'iban';
      } else if (subdomain === 'openkvk') {
        subdomainFolder = 'kvk';
      } else if (subdomain === 'openpostcode') {
        subdomainFolder = 'postal';
      }

      $urlRouterProvider.otherwise('/');

      $stateProvider
        .state('home', {
          url: '/',
          templateUrl: 'views/' + subdomainFolder + '/main.html'
        })
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'views/dashboard/main.html'
        })
        .state('reset', {
          url: '/reset/:token',
          templateUrl: 'views/dashboard/reset.html'
        });

      $stateProvider
        .state('backgrounds', {
          url: '/backgrounds',
          templateUrl: 'views/admin/backgrounds.html'
        });

      $stateProvider
        .state('documentation', {
          url: '/documentation',
          templateUrl: 'views/documentation/main.html'
        })
        .state('documentation.authentication', {
          url: '/authentication',
          templateUrl: 'views/documentation/main/authentication.html'
        })
        .state('documentation.errors', {
          url: '/errors',
          templateUrl: 'views/documentation/main/errors.html'
        })
        .state('documentation.changelog', {
          url: '/changelog',
          templateUrl: 'views/documentation/main/changelog.html'
        })
        .state('documentation.endpoints', {
          url: '/endpoints',
          templateUrl: 'views/documentation/main/endpoints.html'
        });

      $stateProvider
        .state('documentation.ibanCalculation', {
          url: '/iban-calculation',
          templateUrl: 'views/documentation/iban/iban-calculation.html'
        })
        .state('documentation.companySearch', {
          url: '/company-search',
          templateUrl: 'views/documentation/kvk/company-search.html'
        })
        .state('documentation.retrieveAddress', {
          url: '/retrieve-address',
          templateUrl: 'views/documentation/postal/retrieve-address.html'
        })
        .state('documentation.possibleAddresses', {
          url: '/possible-addresses',
          templateUrl: 'views/documentation/postal/possible-addresses.html'
        });

      $stateProvider
        .state('support', {
          url: '/support',
          templateUrl: 'views/support/main.html'
        })
        .state('conditions', {
          url: '/conditions',
          templateUrl: 'views/conditions/main.html'
        })
        .state('privacy', {
          url: '/privacy',
          templateUrl: 'views/privacy/main.html'
        })
        .state('welcome', {
          url: '/welkom/:token',
          templateUrl: 'views/main/welcome.html'
        })
        .state('paymentStatus', {
          url: '/bedankt/:token',
          templateUrl: 'views/main/payment-status.html'
        });

      $locationProvider.html5Mode(true);
    }])
  .run(['$rootScope', 'ContentProvider', 'amMoment', 'AuthService', function($rootScope, ContentProvider, amMoment, AuthService) {
    amMoment.changeLocale('nl');

    $rootScope.$on("$stateChangeSuccess", function () {
      window.scrollTo(0, 0);

      $rootScope.loggedIn = AuthService.isAuthenticated();
    });
  }])
  .filter('sanitize', ['$sce', function($sce) {
    return function(htmlCode){
      return $sce.trustAsHtml(htmlCode);
    };
  }])
  .filter('removeTrailingDot', [function() {
    return function(string) {
      if (string.substring(string.length - 1) === '.') {
        return string.substring(0, string.length - 1);
      } else {
        return string;
      }
    };
  }])
  .filter('floor', [function() {
    return function(n) {
      return Math.floor(n);
    };
  }])
  .filter('cents', [function() {
    return function(n) {
      var cents = Math.round(n * 100) % 100;
      return (cents === 0 ? null : (cents < 10 ? '0' + cents : cents));
    };
  }])
  .filter('formatPrice', [function() {
    return function(n) {
      if (n !== undefined) {
        return n.toFixed(2).replace('.', ',');
      } else {
        return n;
      }
    };
  }]);
